@if (tvLoginStore.translationLoadedForTheFirstTime() && !showSpinner) {
  <div class="login-error">
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none">
      <path
        fill="#CBCBCB"
        fill-rule="evenodd"
        d="M33.167 39a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0ZM32 25c.644 0 1.167.521 1.167 1.167v8.166a1.166 1.166 0 1 1-2.334 0v-8.166c0-.646.523-1.167 1.167-1.167ZM17.742 42.5 32 19.077 46.258 42.5H17.742Zm31.588.56L32.996 16.227c-.422-.697-1.57-.697-1.992 0L14.67 43.06a1.167 1.167 0 0 0 .997 1.773h32.666a1.168 1.168 0 0 0 .997-1.773Z"
        clip-rule="evenodd"
      />
      <path
        fill="#CBCBCB"
        fill-rule="evenodd"
        d="M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28S47.464 4 32 4Zm0 2.333c14.153 0 25.667 11.514 25.667 25.667 0 14.153-11.514 25.667-25.667 25.667C17.847 57.667 6.333 46.153 6.333 32 6.333 17.847 17.847 6.333 32 6.333Z"
        clip-rule="evenodd"
      />
    </svg>

    <h3 class="login-error-title">{{ is500InternalError() ? 500 : '' }} {{ currentError()?.title | translate }}</h3>

    <p class="login-error-text">
      <span
        class="login-error-details"
        [innerHtml]="currentError()?.text ? sanitizeHtml(currentError()?.text | translate) : ''"
      >
      </span>
      @if (currentError()?.contactLink) {
        <open-email />
      }
    </p>
    @if (currentError()?.retryButton) {
      <button type="button" class="login-error-button" (click)="onButtonClick()">
        {{ currentError()?.buttontext | translate }}
      </button>
    }
  </div>
} @else {
  <tvl-spinner-load class="clearfix" [isFullPage]="true" [isShow]="showSpinner"> </tvl-spinner-load>
}
